import script from "./CheatsheetForAfterEffects.vue?vue&type=script&setup=true&lang=js"
export * from "./CheatsheetForAfterEffects.vue?vue&type=script&setup=true&lang=js"

import "./CheatsheetForAfterEffects.vue?vue&type=style&index=0&id=15c73ca8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c73ca8"]])

export default __exports__